import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "sonner";
import LoginPage from "./pages/LoginPage";
import AdminRecoveryPage from "./pages/AdminRecoveryPage";
import AppLayout from "./components/layout/AppLayout";
import DashboardPage from "./pages/DashboardPage";
import CustomersPage from "./pages/CustomersPage";
import TractorsPage from "./pages/TractorsPage";
import PartsPage from "./pages/PartsPage";
import WorkOrdersPage from "./pages/WorkOrdersPage";
import QuotationsPage from "./pages/QuotationsPage";
import FinancePage from "./pages/FinancePage";
import ExpensesPage from "./pages/ExpensesPage";
import ReportsPage from "./pages/ReportsPage";
import UsersPage from "./pages/UsersPage";
import PartRequestsPage from "./pages/PartRequestsPage";
import PartOrdersPage from "./pages/PartOrdersPage";
import CustomerServiceRequestsPage from "./pages/CustomerServiceRequestsPage";
import NotesPage from "./pages/NotesPage";
import NotesCalendarPage from "./pages/NotesCalendarPage";
import SettingsPage from "./pages/SettingsPage";
import PortalPage from "./pages/PortalPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Yükleniyor…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PermRoute({ perm, any, children }) {
  const { user } = useAuth();
  const perms = user?.permissions || [];
  const ok = any ? any.some((p) => perms.includes(p)) : perms.includes(perm);
  if (!ok) return <NoAccess />;
  return children;
}

function NoAccess() {
  return (
    <div className="min-h-[60vh] grid place-items-center text-center px-4">
      <div>
        <div className="text-6xl mb-3">🔒</div>
        <div className="text-xl font-bold text-slate-900">Bu bölüme erişim yetkiniz yok</div>
        <div className="text-sm text-slate-500 mt-1">Yönetici ile iletişime geçin.</div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/kurtarma" element={<AdminRecoveryPage />} />
            <Route path="/portal/:token" element={<PortalPage />} />
            <Route path="/" element={<Protected><AppLayout /></Protected>}>
              <Route index element={<PermRoute perm="dashboard"><DashboardPage /></PermRoute>} />
              <Route path="musteriler" element={<PermRoute perm="customers"><CustomersPage /></PermRoute>} />
              <Route path="traktorler" element={<PermRoute perm="tractors"><TractorsPage /></PermRoute>} />
              <Route path="yedek-parca" element={<PermRoute perm="parts"><PartsPage /></PermRoute>} />
              <Route path="servis" element={<PermRoute perm="service"><WorkOrdersPage /></PermRoute>} />
              <Route path="parca-talepleri" element={<PermRoute perm="part_requests"><PartRequestsPage /></PermRoute>} />
              <Route path="parca-siparisleri" element={<PermRoute perm="part_orders"><PartOrdersPage /></PermRoute>} />
              <Route path="servis-talepleri" element={<PermRoute perm="service_requests"><CustomerServiceRequestsPage /></PermRoute>} />
              <Route path="teklifler" element={<PermRoute perm="quotations"><QuotationsPage /></PermRoute>} />
              <Route path="finans" element={<PermRoute perm="finance"><FinancePage /></PermRoute>} />
              <Route path="giderler" element={<PermRoute any={["expenses_create", "expenses_view"]}><ExpensesPage /></PermRoute>} />
              <Route path="raporlar" element={<PermRoute perm="reports"><ReportsPage /></PermRoute>} />
              <Route path="kullanicilar" element={<PermRoute perm="users"><UsersPage /></PermRoute>} />
              <Route path="senetler" element={<PermRoute perm="notes"><NotesPage /></PermRoute>} />
              <Route path="senet-takvimi" element={<PermRoute perm="notes"><NotesCalendarPage /></PermRoute>} />
              <Route path="ayarlar" element={<PermRoute perm="settings"><SettingsPage /></PermRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}
